<p-iconfield iconPosition="left" style="width: 100%;">
  @if (hasIcon()) {
    <p-inputicon>
      <ng-content></ng-content>
    </p-inputicon>
  }

  @if (isNumberInput()) {
    <p-inputnumber
      [formControl]="formCtrl()"
      [inputId]="inputId()"
      [locale]="'de-DE'"
      [placeholder]="ctrlPlaceholder()"
      [autofocus]="shouldFocus()"
      [disabled]="isDisabled()"
      inputStyleClass="w-full"
      [class]="formCtrlClass()"
      [pKeyFilter]="ctrlKeyFilter()"
      [useGrouping]="ctrlUseGrouping()"
      [currency]="currency()"
      [mode]="currency().length > 0 ? 'currency' : 'decimal'"
    ></p-inputnumber>
  } @else if (btnLabel()) {
    <p-inputgroup class="w-full">
      <input
        pInputText
        (blur)="handleBlur($event)"
        (keyup)="handleKeyUp($event)"
        [formControl]="formCtrl()"
        [id]="inputId()"
        [type]="inputType()"
        [placeholder]="ctrlPlaceholder()"
        autocomplete="off"
        [class]="formCtrlClass() + ' w-full'"
        [autofocus]="shouldFocus()"
        [disabled]="isDisabled()"
        [pKeyFilter]="ctrlKeyFilter()"
      />
      <p-inputgroup-addon>
        <app-button
          [btnSize]="ButtonSize.SM"
          [btnSeverity]="ButtonSeverity.SECONDARY"
          (btnClicked)="handleBtnClick($event)"
        >
          @if (btnIcon()) {
            <app-dynamic-icon
              stroke="#3D3B3A"
              [iconComponent]="btnIcon()"
            ></app-dynamic-icon>
          }
          <div class="text-sm-semibold text-gray-700">{{ btnLabel() }}</div>
        </app-button>
      </p-inputgroup-addon>
    </p-inputgroup>
  } @else {
    <input
      pInputText
      (blur)="handleBlur($event)"
      (keyup)="handleKeyUp($event)"
      [formControl]="formCtrl()"
      [id]="inputId()"
      [type]="inputType()"
      [placeholder]="ctrlPlaceholder()"
      autocomplete="off"
      [class]="formCtrlClass() + ' w-full' + (shortcutHint() ? ' with-shortcut-hint' : '')"
      [autofocus]="shouldFocus()"
      [disabled]="isDisabled()"
      [pKeyFilter]="ctrlKeyFilter()"
    />
    @if (shortcutHint()) {
      <span class="shortcut-hint text-xs-medium" aria-hidden="true">{{ shortcutHint() }}</span>
    }
    @if (isPassword() && !isDisabled()) {
      <p-inputicon class="password-toggle">
        <button
          type="button"
          class="password-toggle__btn"
          [attr.aria-label]="passwordVisible() ? 'Sakrij lozinku' : 'Prikaži lozinku'"
          [attr.aria-pressed]="passwordVisible()"
          (click)="togglePasswordVisible()"
        >
          @if (passwordVisible()) {
            <app-eye-off stroke="#ADB0B8" width="18px" height="18px"></app-eye-off>
          } @else {
            <app-eye stroke="#ADB0B8" width="18px" height="18px"></app-eye>
          }
        </button>
      </p-inputicon>
    }
  }

  @if (tooltip()) {
    <p-inputicon [pTooltip]="tooltip()!" tooltipPosition="top"
                tooltipStyleClass="text-xs-semibold text-center">
    </p-inputicon>
  }
</p-iconfield>


@if (!hideErrors()) {
  @if ((formCtrl().errors?.['required'] || formCtrl().errors?.['invalidGuid']) && (formCtrl().dirty || formCtrl().touched)) {
    <app-error-required [formCtrl]="formCtrl()"></app-error-required>
  }
  @if ((formCtrl().errors?.['maxlength'] || formCtrl().errors?.['max']) && (formCtrl().dirty || formCtrl().touched)) {
    <app-max-length [formCtrl]="formCtrl()"></app-max-length>
  }
  @if (formCtrl().errors?.['min'] && (formCtrl().dirty || formCtrl().touched)) {
    <app-error-min [formCtrl]="formCtrl()"></app-error-min>
  }
}
